export function capitalizeFirstLetter(value: string) {
  return value && value.length ? value.charAt(0).toUpperCase() + value.slice(1) : value;
}
